export { default } from './SpinnerLottie.vue'